/**
 * Issue #272 — 积分规则表单纯助手（解析 / 格式化累加增量序列），便于单测。
 */

/** 把增量序列格式化为「15, 20, 35」供输入框展示。 */
export function incrementsToText(increments: number[]): string {
  return increments.join(', ');
}

/**
 * 解析输入框文本为非负整数增量序列：按逗号 / 中文逗号 / 空白分隔，丢弃非法 / 负数项。
 * 空输入 → 空数组（语义：后续事件不再加分）。
 */
export function parseIncrements(text: string): number[] {
  return text
    .split(/[,，\s]+/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
    .map((s) => Number(s))
    .filter((n) => Number.isFinite(n) && n >= 0)
    .map((n) => Math.round(n));
}

/** 用规则参数预览「前 N 次事件的累计积分」，便于管理员直观校对（与后端 pointsForEvents 同口径）。 */
export function previewCumulativePoints(
  rule: { base: number; increments: number[]; dailyCap: number },
  uptoEvents: number,
): number[] {
  const out: number[] = [];
  let total = 0;
  for (let n = 1; n <= uptoEvents; n++) {
    if (n === 1) total = rule.base;
    else {
      const inc =
        rule.increments.length > 0
          ? rule.increments[Math.min(n - 2, rule.increments.length - 1)] ?? 0
          : 0;
      total += inc;
    }
    out.push(Math.max(0, Math.min(total, rule.dailyCap)));
  }
  return out;
}
